import { getLocale } from "../runtime";

const sv_codeapplied = /** @type {(inputs: {code: NonNullable<unknown>}) => string} */ (inputs) => {
	return `${inputs.code} tillämpad`
};

const codeapplied = /** @type {(inputs: {code: NonNullable<unknown>}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_codeapplied(inputs)
	return "codeApplied";
};

export { codeapplied as "codeApplied" };